// ══════════════════════════════════════════════════════
// TABLAS DE FECHAS TRIBUTARIAS COLOMBIA 2026
// Fuentes: DIAN Dcto.2229/2023 · SDH Bogotá Res.000195/2025
//          UGPP Mi Planilla 2026 · Actualizado Mar-2026
// ══════════════════════════════════════════════════════

// Retención en la Fuente — 12 meses
export const RET = {
  0:["2026-02-23","2026-03-24","2026-04-27","2026-05-26","2026-06-24","2026-07-23","2026-08-26","2026-09-22","2026-10-23","2026-11-25","2026-12-23","2027-01-26"],
  1:["2026-02-10","2026-03-10","2026-04-13","2026-05-12","2026-06-10","2026-07-09","2026-08-12","2026-09-09","2026-10-09","2026-11-11","2026-12-10","2027-01-13"],
  2:["2026-02-11","2026-03-11","2026-04-14","2026-05-13","2026-06-11","2026-07-10","2026-08-13","2026-09-10","2026-10-13","2026-11-12","2026-12-11","2027-01-14"],
  3:["2026-02-12","2026-03-12","2026-04-15","2026-05-14","2026-06-12","2026-07-13","2026-08-14","2026-09-11","2026-10-14","2026-11-13","2026-12-14","2027-01-15"],
  4:["2026-02-13","2026-03-13","2026-04-16","2026-05-15","2026-06-15","2026-07-14","2026-08-17","2026-09-14","2026-10-15","2026-11-16","2026-12-15","2027-01-16"],
  5:["2026-02-16","2026-03-16","2026-04-20","2026-05-19","2026-06-17","2026-07-15","2026-08-19","2026-09-15","2026-10-16","2026-11-18","2026-12-16","2027-01-19"],
  6:["2026-02-17","2026-03-17","2026-04-21","2026-05-20","2026-06-18","2026-07-16","2026-08-20","2026-09-16","2026-10-19","2026-11-19","2026-12-17","2027-01-20"],
  7:["2026-02-18","2026-03-18","2026-04-22","2026-05-21","2026-06-19","2026-07-20","2026-08-21","2026-09-17","2026-10-20","2026-11-20","2026-12-18","2027-01-21"],
  8:["2026-02-19","2026-03-19","2026-04-23","2026-05-22","2026-06-22","2026-07-21","2026-08-24","2026-09-18","2026-10-21","2026-11-23","2026-12-21","2027-01-22"],
  9:["2026-02-20","2026-03-20","2026-04-24","2026-05-25","2026-06-23","2026-07-22","2026-08-25","2026-09-21","2026-10-22","2026-11-24","2026-12-22","2027-01-23"],
};
export const RET_P = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"].map(m=>m+" 2026");

// IVA Bimestral
export const IVA_BIM = {
  0:["2026-03-24","2026-05-26","2026-07-23","2026-09-22","2026-11-25","2027-01-26"],
  1:["2026-03-10","2026-05-12","2026-07-09","2026-09-09","2026-11-11","2027-01-13"],
  2:["2026-03-11","2026-05-13","2026-07-10","2026-09-10","2026-11-12","2027-01-14"],
  3:["2026-03-12","2026-05-14","2026-07-13","2026-09-11","2026-11-13","2027-01-15"],
  4:["2026-03-13","2026-05-15","2026-07-14","2026-09-14","2026-11-16","2027-01-16"],
  5:["2026-03-16","2026-05-19","2026-07-15","2026-09-15","2026-11-18","2027-01-19"],
  6:["2026-03-17","2026-05-20","2026-07-16","2026-09-16","2026-11-19","2027-01-20"],
  7:["2026-03-18","2026-05-21","2026-07-20","2026-09-17","2026-11-20","2027-01-21"],
  8:["2026-03-19","2026-05-22","2026-07-21","2026-09-18","2026-11-23","2027-01-22"],
  9:["2026-03-20","2026-05-25","2026-07-22","2026-09-21","2026-11-24","2027-01-23"],
};
export const IVA_BIM_P = ["Ene-Feb 2026","Mar-Abr 2026","May-Jun 2026","Jul-Ago 2026","Sep-Oct 2026","Nov-Dic 2026"];

// IVA Cuatrimestral
export const IVA_CUAT = {
  0:["2026-05-26","2026-09-22","2027-01-26"],1:["2026-05-12","2026-09-09","2027-01-13"],
  2:["2026-05-13","2026-09-10","2027-01-14"],3:["2026-05-14","2026-09-11","2027-01-15"],
  4:["2026-05-15","2026-09-14","2027-01-16"],5:["2026-05-19","2026-09-15","2027-01-19"],
  6:["2026-05-20","2026-09-16","2027-01-20"],7:["2026-05-21","2026-09-17","2027-01-21"],
  8:["2026-05-22","2026-09-18","2027-01-22"],9:["2026-05-25","2026-09-21","2027-01-23"],
};
export const IVA_CUAT_P = ["Ene-Abr 2026","May-Ago 2026","Sep-Dic 2026"];

// IVA Anual
export const IVA_ANUAL = {
  0:["2027-01-26"],1:["2027-01-13"],2:["2027-01-14"],3:["2027-01-15"],
  4:["2027-01-16"],5:["2027-01-19"],6:["2027-01-20"],7:["2027-01-21"],
  8:["2027-01-22"],9:["2027-01-23"],
};

// Renta Personas Jurídicas
export const RENTA = {
  0:["2026-05-26","2026-07-23"],1:["2026-05-12","2026-07-09"],2:["2026-05-13","2026-07-10"],
  3:["2026-05-14","2026-07-13"],4:["2026-05-15","2026-07-14"],5:["2026-05-19","2026-07-15"],
  6:["2026-05-20","2026-07-16"],7:["2026-05-21","2026-07-20"],8:["2026-05-22","2026-07-21"],
  9:["2026-05-25","2026-07-22"],
};
export const RENTA_P = ["1ra Cuota + Declaración Renta AG 2025","2da Cuota Renta AG 2025"];

// RUB — Beneficiarios Finales (independiente del dígito)
export const RUB_D = ["2026-02-02","2026-05-04","2026-08-03","2026-11-03"];
export const RUB_P = ["Actualización RUB Q1","Actualización RUB Q2","Actualización RUB Q3","Actualización RUB Q4"];

// Exógena DIAN AG 2025
export const EXOG_D = "2026-06-12";

// Bogotá — ICA Bimestral
export const BOG_ICA_D = ["2026-04-10","2026-06-12","2026-08-14","2026-10-09","2026-11-13","2027-02-12"];
export const BOG_ICA_P = ["ICA Bogotá Bim.1 Ene-Feb","ICA Bogotá Bim.2 Mar-Abr","ICA Bogotá Bim.3 May-Jun","ICA Bogotá Bim.4 Jul-Ago","ICA Bogotá Bim.5 Sep-Oct","ICA Bogotá Bim.6 Nov-Dic"];
export const BOG_RET_D = ["2026-03-20","2026-05-22","2026-07-17","2026-09-18","2026-11-20","2027-01-15"];

// Mi Planilla PILA — por dos últimos dígitos del NIT
export const PILA_GRUPOS = [
  [0,  7,  ["2026-02-03","2026-03-03","2026-04-06","2026-05-05","2026-06-02","2026-07-02","2026-08-04","2026-09-02","2026-10-02","2026-11-04","2026-12-02","2027-01-05"]],
  [8,  14, ["2026-02-04","2026-03-04","2026-04-07","2026-05-06","2026-06-03","2026-07-03","2026-08-05","2026-09-03","2026-10-05","2026-11-05","2026-12-03","2027-01-06"]],
  [15, 21, ["2026-02-05","2026-03-05","2026-04-08","2026-05-07","2026-06-04","2026-07-06","2026-08-06","2026-09-04","2026-10-06","2026-11-06","2026-12-04","2027-01-07"]],
  [22, 28, ["2026-02-06","2026-03-06","2026-04-09","2026-05-08","2026-06-05","2026-07-07","2026-08-10","2026-09-07","2026-10-07","2026-11-09","2026-12-07","2027-01-08"]],
  [29, 35, ["2026-02-09","2026-03-09","2026-04-10","2026-05-11","2026-06-09","2026-07-08","2026-08-11","2026-09-08","2026-10-08","2026-11-10","2026-12-09","2027-01-11"]],
  [36, 42, ["2026-02-10","2026-03-10","2026-04-13","2026-05-12","2026-06-10","2026-07-09","2026-08-12","2026-09-09","2026-10-09","2026-11-11","2026-12-10","2027-01-13"]],
  [43, 49, ["2026-02-11","2026-03-11","2026-04-14","2026-05-13","2026-06-11","2026-07-10","2026-08-13","2026-09-10","2026-10-13","2026-11-12","2026-12-11","2027-01-14"]],
  [50, 56, ["2026-02-12","2026-03-12","2026-04-15","2026-05-14","2026-06-12","2026-07-13","2026-08-14","2026-09-11","2026-10-14","2026-11-13","2026-12-14","2027-01-15"]],
  [57, 63, ["2026-02-13","2026-03-13","2026-04-16","2026-05-15","2026-06-16","2026-07-14","2026-08-18","2026-09-14","2026-10-15","2026-11-17","2026-12-15","2027-01-18"]],
  [64, 69, ["2026-02-16","2026-03-16","2026-04-17","2026-05-19","2026-06-17","2026-07-15","2026-08-19","2026-09-15","2026-10-16","2026-11-18","2026-12-16","2027-01-19"]],
  [70, 75, ["2026-02-17","2026-03-17","2026-04-20","2026-05-20","2026-06-18","2026-07-16","2026-08-20","2026-09-16","2026-10-19","2026-11-19","2026-12-17","2027-01-20"]],
  [76, 81, ["2026-02-18","2026-03-18","2026-04-21","2026-05-21","2026-06-19","2026-07-17","2026-08-21","2026-09-17","2026-10-20","2026-11-20","2026-12-18","2027-01-21"]],
  [82, 87, ["2026-02-19","2026-03-19","2026-04-22","2026-05-22","2026-06-22","2026-07-21","2026-08-24","2026-09-18","2026-10-21","2026-11-23","2026-12-21","2027-01-22"]],
  [88, 93, ["2026-02-20","2026-03-20","2026-04-23","2026-05-25","2026-06-23","2026-07-22","2026-08-25","2026-09-21","2026-10-22","2026-11-24","2026-12-22","2027-01-25"]],
  [94, 99, ["2026-02-23","2026-03-24","2026-04-24","2026-05-26","2026-06-24","2026-07-23","2026-08-26","2026-09-22","2026-10-23","2026-11-25","2026-12-23","2027-01-26"]],
];
export const PLANILLA_P = ["Planilla Enero 2026","Planilla Febrero 2026","Planilla Marzo 2026","Planilla Abril 2026","Planilla Mayo 2026","Planilla Junio 2026","Planilla Julio 2026","Planilla Agosto 2026","Planilla Septiembre 2026","Planilla Octubre 2026","Planilla Noviembre 2026","Planilla Diciembre 2026"];

// Patrón estimado Exógena Distrital Bogotá AG 2025 (por confirmar resolución SDH)
export const DIB_PATRON = {
  0:"2026-09-01",1:"2026-09-02",2:"2026-09-03",3:"2026-09-04",
  4:"2026-09-07",5:"2026-09-08",6:"2026-09-09",7:"2026-09-10",
  8:"2026-09-11",9:"2026-09-12"
};

// ──────────────────────────────────────────────────────
// UTILIDADES
// ──────────────────────────────────────────────────────
export function calcDV(nit) {
  const n = nit.toString().replace(/\D/g, "");
  if (n.length < 1) return null;
  const f = [71,67,59,53,47,43,41,37,29,23,19,17,13,7,3];
  let s = 0;
  for (let i = 0; i < n.length; i++) s += parseInt(n[n.length-1-i]) * (f[f.length-1-i] || 1);
  const r = s % 11;
  return r < 2 ? r : (11 - r);
}

export function getPilaFechas(nit) {
  const clean = nit.replace(/\D/g, "");
  const dos = parseInt(clean.slice(-2));
  for (const [lo, hi, fechas] of PILA_GRUPOS) {
    if (dos >= lo && dos <= hi) return fechas;
  }
  return PILA_GRUPOS[PILA_GRUPOS.length-1][2];
}

export function getPilaDiaHabil(nit) {
  const clean = nit.replace(/\D/g, "");
  const dos = parseInt(clean.slice(-2));
  const map = {0:2,8:3,15:4,22:5,29:6,36:7,43:8,50:9,57:10,64:11,70:12,76:13,82:14,88:15,94:16};
  const grupo = PILA_GRUPOS.find(([lo,hi]) => dos >= lo && dos <= hi);
  return grupo ? (map[grupo[0]] || 2) : 2;
}

export function hoy() {
  const h = new Date();
  return new Date(h.getFullYear(), h.getMonth(), h.getDate());
}

export function diasRestantes(f) {
  if (!f) return null;
  const [y,m,d] = f.split("-").map(Number);
  return Math.floor((new Date(y,m-1,d) - hoy()) / 86400000);
}

export function claseSemaforo(dias, fecha) {
  if (!fecha) return "g";
  if (dias <= 0) return "r";
  if (dias <= 15) return "a";
  return "v";
}

export function formatFecha(f) {
  if (!f) return "⚠️ Por confirmar";
  const [y,m,d] = f.split("-").map(Number);
  const meses = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
  return `${String(d).padStart(2,"0")}-${meses[m-1]}-${y}`;
}

export function estadoTexto(cl, dias) {
  if (cl === "g") return "⬜ Por confirmar";
  if (cl === "r") return dias === 0 ? "🔴 ¡HOY!" : `🔴 Venció ${Math.abs(dias)}d`;
  if (cl === "a") return `🟡 ${dias} días`;
  return `🟢 ${dias} días`;
}

// ──────────────────────────────────────────────────────
// GENERADOR PRINCIPAL DE VENCIMIENTOS
// ──────────────────────────────────────────────────────
export function generarVencimientos(nit, regimen, municipio) {
  const clean = nit.replace(/\D/g, "");
  const dig = parseInt(clean[clean.length-1]);
  const all = [];
  const push = (ent, ob, cat, per, f, norma, tag) => all.push({ent,ob,cat,per,f,norma,tag});

  // IVA
  if (regimen === "bim") {
    IVA_BIM[dig].forEach((f,i) => push("DIAN","IVA Bimestral","IVA",IVA_BIM_P[i],f,"DIAN Dcto.2229/2023","dian"));
  } else if (regimen === "cuat") {
    IVA_CUAT[dig].forEach((f,i) => push("DIAN","IVA Cuatrimestral","IVA",IVA_CUAT_P[i],f,"DIAN Dcto.2229/2023","dian"));
  } else {
    IVA_ANUAL[dig].forEach(f => push("DIAN","IVA Anual","IVA","Año 2026",f,"DIAN Dcto.2229/2023","dian"));
  }

  // Retención
  RET[dig].forEach((f,i) => push("DIAN","Retención en la Fuente","Retención","Período "+RET_P[i],f,"DIAN Dcto.2229/2023","dian"));

  // Renta
  RENTA[dig].forEach((f,i) => push("DIAN","Renta Personas Jurídicas","Renta",RENTA_P[i],f,"DIAN Dcto.2229/2023","dian"));

  // RUB
  RUB_D.forEach((f,i) => push("DIAN","Benef. Finales – RUB","RUB",RUB_P[i],f,"DIAN Dcto.2229/2023","dian"));

  // Exógena DIAN
  push("DIAN","Exógena DIAN AG 2025","Exógena","Pers.Jurídicas · 14-May al 12-Jun",EXOG_D,"Res.000227+000233/2025","dian");

  // Mi Planilla PILA
  const pilaFechas = getPilaFechas(nit);
  const dhNum = getPilaDiaHabil(nit);
  pilaFechas.forEach((f,i) => push("Mi Planilla",`Pago PILA (día hábil ${dhNum})`,"Planilla",PLANILLA_P[i],f,"Dcto.780/2016 Art.3.2.2.1","pla"));

  // Bogotá
  if (municipio === "bogota") {
    BOG_ICA_D.forEach((f,i) => push("S.H. Bogotá","ICA Bogotá","ICA-BOG",BOG_ICA_P[i],f,"SDH Res.000195/2025","bog"));
    BOG_RET_D.forEach((f,i) => push("S.H. Bogotá","ReteICA Bogotá","ReteICA-BOG",BOG_ICA_P[i],f,"SDH Res.000195/2025","bog"));
    const dig2 = parseInt(clean[clean.length-1]);
    const dibFecha = DIB_PATRON[dig2];
    push("S.H. Bogotá","Exógena Distrital AG 2025","Exógena","⚠️ Estimada (patrón AG 2024)",dibFecha,"Res. DDI 2026 (pendiente)","bog");
  }

  return all;
}
